import { sys } from '@/api';

const state = {
  data: {}
};

const mutations = {
  CLAER_DATA(state) {
    state.data = {};
  },
  SET_DATA(state, playload) {
    state.data = playload;
  }
};
const actions = {
  async getData({ commit, state }) {
    if (state.data && Object.keys(state.data).length) {
      return { ...state.data };
    }
    const res = await sys.globalConfig({});
    let playload = {};
    if (res && res.data) {
      playload = res.data.global_config.config;
    }
    commit('SET_DATA', playload);
    return playload;
  },
  async setData({ commit, dispatch }, playload) {
    const res = await sys.globalConfig({
      params: playload,
      methold: 'put'
    });
    if (res) {
      commit('CLAER_DATA', playload);
      dispatch('getData');
      return res;
    }
    return false;
  }
};

const globalConfig = {
  namespaced: true,
  state,
  mutations,
  actions
};

export default globalConfig;
